import $ from 'jquery'
import 'slick-carousel'
import '!vue-style!css!slick-carousel/slick/slick.css'
import '!vue-style!css!slick-carousel/slick/slick-theme.css'

export default {
  install (Vue) {
    let options = {
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1
    }

    Vue.directive('slick', {
      bind () {
        try {
          $(this.el).slick(options)
        } catch (e) {
          console.log(e)
        }
      },
      update (val) {
        $(this.el).slick('unslick')
        setTimeout(() => {
          this.bind()
        })
      },
      unbind () {
        $(this.el).slick('unslick')
      }
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/directives/v-slick.js
 **/